import React from "react"

import { ProjectChildMultiSelectSidebar } from "pages/project-page/sidebar/multi/project-child/ProjectChildMultiSelectSidebar"
import {
  UseProjectChildMultiSelectSidebarModelArgs,
  useProjectChildMultiSelectSidebarModel
} from "pages/project-page/sidebar/multi/project-child/hooks/useProjectChildMultiSelectSidebarModel"

export const SharedProjectPageProjectChildMultiSelectSidebarConnector =
  React.memo((props: UseProjectChildMultiSelectSidebarModelArgs) => (
    <ProjectChildMultiSelectSidebar
      {...useProjectChildMultiSelectSidebarModel(props)}
      hideControls
    />
  ))
